"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfInviteCreateDto = instanceOfInviteCreateDto;
exports.InviteCreateDtoFromJSON = InviteCreateDtoFromJSON;
exports.InviteCreateDtoFromJSONTyped = InviteCreateDtoFromJSONTyped;
exports.InviteCreateDtoToJSON = InviteCreateDtoToJSON;
exports.InviteCreateDtoToJSONTyped = InviteCreateDtoToJSONTyped;
/**
 * Check if a given object implements the InviteCreateDto interface.
 */
function instanceOfInviteCreateDto(value) {
    if (!('emails' in value) || value['emails'] === undefined)
        return false;
    return true;
}
function InviteCreateDtoFromJSON(json) {
    return InviteCreateDtoFromJSONTyped(json, false);
}
function InviteCreateDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'clientId': json['clientId'] == null ? undefined : json['clientId'],
        'emails': json['emails'],
    };
}
function InviteCreateDtoToJSON(json) {
    return InviteCreateDtoToJSONTyped(json, false);
}
function InviteCreateDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'clientId': value['clientId'],
        'emails': value['emails'],
    };
}
//# sourceMappingURL=InviteCreateDto.js.map